import 'react-phone-number-input/style.css'
import "./styles.css"
import PhoneInput, { parsePhoneNumber } from 'react-phone-number-input'

function CustomPhoneInput({value, onChange, noPadding, ...rest}) {
  
  const handleChange = (phoneNumber) => {
    if(phoneNumber){
      const phoneDetails = parsePhoneNumber(phoneNumber);
      const countryCode = phoneDetails?.countryCallingCode || "+1";
      const country = phoneDetails?.country || "US";
      const actualNumber = phoneDetails?.nationalNumber || "";
      onChange({ phoneNumber, countryCode, country, actualNumber });
    }
    else {
      onChange({ phoneNumber: '', countryCode: '', country: '' });
    }
  }

  return (
    <div className={`custom-phone-input ${noPadding ? "signup-phone-input" : ""}` }>
      <PhoneInput
        placeholder="Enter phone number"
        value={value}
        onChange={handleChange}
        defaultCountry='US'
        {...rest}
      />
    </div>
  )
}

export default CustomPhoneInput